import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import View from 'src/components/view';
import Element from 'src/components/element';
import utils from 'src/components/utils';
import DialogObservacoesSPV from 'src/components/relatorios/dialog_observacoes_spv';

function HistoricoComissao() {
  let [openObservacaoDialog, setOpenObservacaoDialog] = useState(false);
  let [observacaoSelecionada, setObservacaoSelecionada] = useState('');
  let view = {};
  let crud = { data: {}, changed: {}, requireds: {} };
  let user = utils.getUser();

  const openObservationDialog = function (_element, args) {
    setObservacaoSelecionada(args?.data?.observacao || '');
    setOpenObservacaoDialog(true);
  };

  crud.openObservationDialog = openObservationDialog;
  view.openObservationDialog = openObservationDialog;

  const consultores = {
    label: utils.lng('titulo_spv', 'Serviço e promoção de vendas - SPV'),
    type: 'list',
    list: {
      url: 'report_pontos_saldo_spv_erp?id_usuario=' + user.id,
    },
    columns: {
      pais_desc: { field: 'pais_desc', label: utils.lng('pais', 'País'), filter: true, sort: true },
      mes: {
        field: 'mes',
        value: '${@this.mes}',
        label: utils.lng('referencia_mes', 'Mês Ref.'),
        filter: true,
        format: 'month_year',
        type: 'span',
        sort: true,
      },
      valor: {
        type: 'span',
        field: 'valor',
        format: 'number',
        label: utils.lng('valor', 'Valor'),
      },
      moeda_desc: { field: 'moeda_desc', label: utils.lng('moeda', 'Moeda'), filter: true, sort: true },
      informe: { field: 'informe', label: utils.lng('informe', 'Informe') },
      fatura: { field: 'fatura', label: utils.lng('fatura', 'Fatura') },
      status_desc: { field: 'status_desc', label: utils.lng('status_desc', 'Status'), filter: true, sort: true },
      observacao: {
        field: 'observacao',
        label: utils.lng('observacao', 'Observação'),
      },
    },
  };

  return (
    <>
      <View name="rel-pontos-spv" className="ui-view-report">
        <Element value={consultores} crud={crud} data={crud.data} view={view}></Element>
      </View>
      <Dialog open={openObservacaoDialog} onClose={() => setOpenObservacaoDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>{utils.lng('observacao', 'Observação')}</DialogTitle>
        <DialogContent>
          <DialogObservacoesSPV observacao={observacaoSelecionada} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenObservacaoDialog(false)} color="primary">
            {utils.lng('fechar', 'Fechar')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

// País 	País
// Mês Ref. 	Período
// Valor 	Valor
// Moeda 	Moneda
// Informe 	Informe*
// Fatura 	Factura*
// Status 	Estado
// Observação 	Observación

export default HistoricoComissao;
